(function () {
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();

/* Product page: variant selection */
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var dataEl = root.querySelector('[data-pdp-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = root.querySelector('[data-pdp-variant-id]');
  var priceEl = root.querySelector('[data-pdp-price]');
  var submit = root.querySelector('[data-pdp-submit]');
  var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option-index]'));

  function money(cents) {
    var fmt = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function selected() {
    return fieldsets.map(function (fs) {
      var input = fs.querySelector('input:checked');
      return input ? input.value : null;
    });
  }

  function update() {
    var opts = selected();

    fieldsets.forEach(function (fs) {
      var legendValue = fs.querySelector('[data-pdp-option-selected]');
      var input = fs.querySelector('input:checked');
      if (legendValue && input) legendValue.textContent = input.value;
    });

    // mark unavailable values for the last option group
    fieldsets.forEach(function (fs, index) {
      fs.querySelectorAll('[data-pdp-option-input]').forEach(function (input) {
        var trial = opts.slice();
        trial[index] = input.value;
        var match = variants.find(function (v) {
          return trial.every(function (val, i) { return val === null || v.options[i] === val; });
        });
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !match || !match.available);
      });
    });

    var variant = variants.find(function (v) {
      return opts.every(function (val, i) { return val === null || v.options[i] === val; });
    });

    if (!variant) {
      submit.disabled = true;
      submit.textContent = 'Unavailable';
      return;
    }

    idInput.value = variant.id;
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'Add to cart' : 'Sold out';

    var html = '<span class="pdp__price-current">' + money(variant.price) + '</span>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<s class="pdp__price-compare">' + money(variant.compare_at_price) + '</s>';
    }
    priceEl.innerHTML = html;

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  root.querySelectorAll('[data-pdp-option-input]').forEach(function (input) {
    input.addEventListener('change', update);
  });

  update();
})();
